import styled from 'styled-components';

const Wrapper = styled.div`
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(122, 31, 43, 0.08);
`;

const Header = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #7a1f2b 0%, #8d2433 100%);
  color: #fff;
  font-weight: 700;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 1rem;
  padding: 1rem 1.25rem;
  align-items: center;
  border-bottom: 1px solid rgba(122, 31, 43, 0.08);
  transition: background 0.2s ease;

  &:hover {
    background: rgba(122, 31, 43, 0.03);
  }

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 1rem;
  }
`;

const Day = styled.div`
  font-weight: 700;
  color: #2d2d2d;
`;

const TimeBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const MobileLabel = styled.span`
  display: none;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #7a1f2b;

  @media (max-width: 768px) {
    display: inline-block;
  }
`;

const TimeValue = styled.span`
  color: ${({ $closed }) => ($closed ? '#a94442' : '#333')};
  font-weight: ${({ $closed }) => ($closed ? '700' : '500')};
`;

function OpeningHours({ items = [] }) {
  return (
    <Wrapper>
      <Header>
        <div>Tag</div>
        <div>Öffnungszeiten</div>
        <div>Küche</div>
      </Header>

      {items.map((item) => {
        const isClosed = item.open?.toLowerCase().includes('ruhetag');
        const kitchenClosed = item.kitchen?.toLowerCase().includes('ruhetag');

        return (
          <Row key={item.day}>
            <Day>{item.day}</Day>

            <TimeBlock>
              <MobileLabel>Öffnungszeiten</MobileLabel>
              <TimeValue $closed={isClosed}>{item.open}</TimeValue>
            </TimeBlock>

            <TimeBlock>
              <MobileLabel>Küche</MobileLabel>
              <TimeValue $closed={kitchenClosed}>
                {item.kitchen}
              </TimeValue>
            </TimeBlock>
          </Row>
        );
      })}
    </Wrapper>
  );
}

export default OpeningHours;